import React from "react";
import { CardText } from "reactstrap";

const TextWrapper = ({ children, className, onClick }) => (
  <CardText onClick={onClick} className={className}>
    {children}
  </CardText>
);

export default TextWrapper;
